import { Card, CardContent, Fab, Icon } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS } from '../../redux/authorizedApps/authorizedAppsConstants';
import { downloadReactTableAsXlsx, formatAmountToString } from '../../utils';
import CustomizedTextField from '../Input/CustomizedTextField';

class AffairsCounters extends Component {

    download() {
        if (this.props.affairs.filteredAndSortedAffairs.length <= 0)
            return;

        downloadReactTableAsXlsx(this.props.affairs.filteredAndSortedAffairs, this.props.columns, "ContratsEtAffaires")
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin counters-card without-side-padding-only-small-screen">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-padding">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-3 control-margin-top">
                        {this.props.affairs.filteredAndSortedAffairs.length > 0 ? (
                            <Fab variant="extended" type="submit" className="div-center" color="secondary" onClick={this.download.bind(this)}>
                                <Icon>download</Icon>
                            </Fab>
                        ) : null}
                    </div>
                    <div className="offset-lg-3 col-lg-3 col-md-4 col-sm-6 col-9">
                        <CustomizedTextField
                            id="nb-total-affairs"
                            label="Nb affaires"
                            className="full_size light-disabled"
                            value={this.props.tableState.nbTotalResults[MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS]}
                            margin="normal"
                        />
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                        <CustomizedTextField
                            id="total-amount"
                            label="Total HT"
                            className="full_size light-disabled"
                            value={formatAmountToString(this.props.affairs.totalAmount)}
                            margin="normal"
                        />
                    </div>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affairs: state.affairs,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AffairsCounters);
